@if (tokenSent) {
<h1 class="text-center">{{ "RESET_LINK_SENT" | translate }}</h1>
<h3 class="font-base text-white text-center">
  {{ "CHECK_EMAILS_REGEN_PASSWORD" | translate }}
</h3>

<div class="link mt-4">
  <a class="arrow-back text-white!" routerLink="/">{{
    "LOG_IN" | translate
  }}</a>
</div>
} @else {
<h1 class="text-center">{{ "RESET_PASSWORD" | translate }}</h1>
<form [formGroup]="sendTokenForm" (ngSubmit)="onSubmit()">
  <input
    type="email"
    formControlName="email"
    [placeholder]="'EMAIL' | translate"
  />
  @if (sendTokenForm.get('email')?.touched) { @if
  (sendTokenForm.get('email')?.hasError('required')) {
  <div class="error">
    {{ "EMAIL_REQUIRED" | translate }}
  </div>
  } @if (sendTokenForm.get('email')?.hasError('email')) {
  <div class="error">
    {{ "INVALID_EMAIL" | translate }}
  </div>
  } } @if (error) {
  <div class="error">
    {{ error.error.error | translate }}
  </div>
  }
  <button type="submit">{{ "SEND_RESET_LINK" | translate }}</button>

  <div class="link mt-4">
    <a class="arrow-back text-white!" routerLink="/">{{
      "LOG_IN" | translate
    }}</a>
  </div>
</form>
}
